/*
 * Action Types
 */
export enum WalletExpirationSettingsTypes {
  GET_WALLET_EXPIRATION_SETTINGS_REQUEST = '@walletExpirationSettings/GET_WALLET_EXPIRATION_SETTINGS_REQUEST',
  GET_WALLET_EXPIRATION_SETTINGS_SUCCESS = '@walletExpirationSettings/GET_WALLET_EXPIRATION_SETTINGS_SUCCESS',
  GET_WALLET_EXPIRATION_SETTINGS_FAILURE = '@walletExpirationSettings/GET_WALLET_EXPIRATION_SETTINGS_FAILURE',

  UPDATE_WALLET_EXPIRATION_SETTINGS_REQUEST = '@walletExpirationSettings/UPDATE_WALLET_EXPIRATION_SETTINGS_REQUEST',
  UPDATE_WALLET_EXPIRATION_SETTINGS_SUCCESS = '@walletExpirationSettings/UPDATE_WALLET_EXPIRATION_SETTINGS_SUCCESS',
  UPDATE_WALLET_EXPIRATION_SETTINGS_FAILURE = '@walletExpirationSettings/UPDATE_WALLET_EXPIRATION_SETTINGS_FAILURE',
}

/*
 * Data types
 */
export interface WalletExpirationSettingsInterface {
  id?: string;
  transportOperatorId?: string;
  expirationType?: number;
  expirationDays?: number | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
}

/*
 * State type
 */
export interface WalletExpirationSettingsState {
  readonly walletExpirationSettingsData: WalletExpirationSettingsInterface;
  readonly loading: boolean;
  readonly error: boolean;
}
